import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useAuth0 } from '@auth0/auth0-react';
import { useMe } from '../hooks/useMe';
import { useI18n } from '../i18n';
import LanguageToggle from '../components/LanguageToggle';

// Pantalla completa para quien no está en cs_owners o aún no tiene acceso.
// No monta Layout a propósito: sin pestañas, sin datos, sin consola.
export default function NoAccess() {
  const { logout, user } = useAuth0();
  const { me } = useMe();
  const { t } = useI18n();
  const registered = me?.registered;

  return (
    <Box sx={{
      minHeight: '100vh', backgroundColor: '#F5F5F5',
      display: 'grid', placeItems: 'center', p: 3,
    }}>
      <Box sx={{
        maxWidth: 470, width: '100%', backgroundColor: '#fff',
        border: '1px solid #E4E0E2', borderRadius: '5px', p: 4, textAlign: 'center',
      }}>
        <Typography sx={{ fontWeight: 600, fontSize: 17, mb: 0.5 }}>
          {t('layout.brandPrefix')}{' '}
          <Box component="span" sx={{ color: '#FF6666' }}>{t('layout.brandName')}</Box>
        </Typography>

        <Box sx={{
          width: 44, height: 44, borderRadius: '50%', backgroundColor: '#EDE6E3',
          display: 'grid', placeItems: 'center', margin: '18px auto',
          fontSize: 20, color: '#847782',
        }}>🔒</Box>

        <Typography sx={{ fontSize: 16, fontWeight: 500, mb: 1 }}>
          {registered ? t('noAccess.pendingTitle') : t('noAccess.deniedTitle')}
        </Typography>

        <Typography sx={{ fontSize: 13.5, color: '#847782', mb: 3, lineHeight: 1.6 }}>
          {registered ? t('noAccess.pendingBody') : t('noAccess.deniedBody')}
        </Typography>

        <Box sx={{
          backgroundColor: '#F5F5F5', border: '1px solid #E4E0E2', borderRadius: '4px',
          px: 2, py: 1.2, mb: 3, fontSize: 13,
        }}>
          {me?.email || user?.email || user?.sub}
        </Box>

        <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', alignItems: 'center' }}>
          <Button
            variant="outlined"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            sx={{ color: '#531253', borderColor: '#E4E0E2', fontSize: 13 }}
          >
            {t('layout.logout')}
          </Button>
          <LanguageToggle />
        </Box>
      </Box>
    </Box>
  );
}
